// @owners { team: patient-fulfillment }
export const IMAGE_DIMENSIONS = {
  width: 328,
  height: 268,
};
